import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { GoogleDriveDto } from 'src/app/sungeo/model/google-drive-dto'
import { Observable } from 'rxjs'

declare const gapi: any
declare const google: any

@Injectable({
  providedIn: 'root'
})
export class GoogleDrivePickerService {

  constructor(private http: HttpClient) {
  }

  private developerKey = 'AIzaSyDY6KXjirpX6Uz_70WFaiLALR2xn4d_iZI'
  private appId = 'upbeat-nectar-469607-c7'

  private pickerCallback: any = null
  private oauthAccessToken: any = null
  private pickerApiLoaded = false

  public openGooglePicker(callback: any): void {
    this.pickerCallback = callback
    if (!this.oauthAccessToken) {
      gapi.load('auth', { 'callback': this.connectWithToken.bind(this) })
    }else{
      gapi.load('picker', { 'callback': this.onPickerApiLoad.bind(this) })
    }
  }

  private connectWithToken() : void {
    const path = `${environment.baseUrl}/googledrive/token`
    this.http.get(path, {responseType: 'text'}).subscribe(token => {

      this.oauthAccessToken = token;

      if(token) {
        gapi.load('picker', { 'callback': this.onPickerApiLoad.bind(this) })
      }
    });
  }

  private onPickerApiLoad(): void {
    this.pickerApiLoaded = true
    this.tryCreatePicker()
  }

  private tryCreatePicker(): void {
    if (
      this.pickerApiLoaded &&
      this.oauthAccessToken
    ) {
      this.createPicker();
    } else {
      console.warn('Conditions non remplies. pickerApiLoaded:', this.pickerApiLoaded, 'token:', this.oauthAccessToken);
    }
  }

  private createPicker(): void {

    if (this.pickerApiLoaded && this.oauthAccessToken) {

      const folderId = environment.googleDriveFolderId

      let pickerBuilder = new google.picker.PickerBuilder()

      const view = new google.picker.DocsView()
        .setMimeTypes('application/vnd.google-apps.folder')
        .setIncludeFolders(true)
        .setEnableDrives(true)
        .setSelectFolderEnabled(true)
        .setParent(folderId);

      const picker = pickerBuilder
        .addView(view)
        .setAppId(this.appId)
        .setOAuthToken(this.oauthAccessToken)
        .setCallback(this.pickerCallback.bind(this))
        .build()
      picker.setVisible(true)
    }
  }

  saveToFolder(googleDriveDto : GoogleDriveDto): Observable<any> {
    const path = `${environment.baseUrl}/googledrive/save`
    const formData = new FormData();
    formData.append('screenshot', googleDriveDto.screenshot);      
    formData.append('folderId', googleDriveDto.folderId);    
    formData.append('urlDownloadSimu', googleDriveDto.urlDownloadSimu);
    formData.append('simuFileName', googleDriveDto.simuFileName);
  
    if (googleDriveDto.csvPresentation) {
      formData.append('csvPresentation', googleDriveDto.csvPresentation);
    }
    if (googleDriveDto.csvDevis) {
      formData.append('csvDevis', googleDriveDto.csvDevis);
    }
    if (googleDriveDto.csvVE) {
      formData.append('csvVE', googleDriveDto.csvVE);
    }

    return this.http.post(path, formData);
  }

}
